import { c as _c } from "react/compiler-runtime";
import { CacheKey } from '@libs/vercel';
import Invalid from './invalid.icon.svg';
import Valid from './valid.icon.svg';
import css from './verified.module.scss';
interface Props {
  value: string;
}
export function Verified(t0) {
  const $ = _c(12);
  const {
    value
  } = t0;
  const valid = CacheKey.isValid(value);
  const Icon = valid ? Valid : Invalid;
  let t1;
  if ($[0] !== Icon) {
    t1 = <span className={css.badge}><Icon /></span>;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = valid ? "Verified" : "Invalid";
  let t3;
  if ($[2] !== t2) {
    t3 = <p className={css.title}>{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = valid ? "This cache key is valid and ready to use." : "Cache key format is invalid.";
  let t5;
  if ($[4] !== t4) {
    t5 = <p className={css.subtitle}>{t4}</p>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t6) {
    t7 = <div className={css.verified}>{t1}{t6}</div>;
    $[9] = t1;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}